// src/universal/common/stringHelpers.ts
var compareString = (str1, str2) => {
  if (!str1 || !str2) {
    return false;
  }
  return str1.toLowerCase() === str2.toLowerCase();
};
var charMap = {
  // Vietnamese vowels
  \u00E0: "a",
  \u00E1: "a",
  \u1EA1: "a",
  \u1EA3: "a",
  \u00E3: "a",
  \u00E2: "a",
  \u1EA7: "a",
  \u1EA5: "a",
  \u1EAD: "a",
  \u1EA9: "a",
  \u1EAB: "a",
  \u0103: "a",
  \u1EB1: "a",
  \u1EAF: "a",
  \u1EB7: "a",
  \u1EB3: "a",
  \u1EB5: "a",
  \u00E8: "e",
  \u00E9: "e",
  \u1EB9: "e",
  \u1EBB: "e",
  \u1EBD: "e",
  \u00EA: "e",
  \u1EC1: "e",
  \u1EBF: "e",
  \u1EC7: "e",
  \u1EC3: "e",
  \u1EC5: "e",
  \u00EC: "i",
  \u00ED: "i",
  \u1ECB: "i",
  \u1EC9: "i",
  \u0129: "i",
  \u00F2: "o",
  \u00F3: "o",
  \u1ECD: "o",
  \u1ECF: "o",
  \u00F5: "o",
  \u00F4: "o",
  \u1ED3: "o",
  \u1ED1: "o",
  \u1ED9: "o",
  \u1ED5: "o",
  \u1ED7: "o",
  \u01A1: "o",
  \u1EDD: "o",
  \u1EDB: "o",
  \u1EE3: "o",
  \u1EDF: "o",
  \u1EE1: "o",
  \u00F9: "u",
  \u00FA: "u",
  \u1EE5: "u",
  \u1EE7: "u",
  \u0169: "u",
  \u01B0: "u",
  \u1EEB: "u",
  \u1EE9: "u",
  \u1EF1: "u",
  \u1EED: "u",
  \u1EEF: "u",
  \u1EF3: "y",
  \u00FD: "y",
  \u1EF5: "y",
  \u1EF7: "y",
  \u1EF9: "y",
  \u0111: "d"
};
var slugify = (str) => {
  const TRIM_REGEX = /^\s+|\s+$/g;
  const INVALID_CHARS_REGEX = /[^a-z0-9 -]/g;
  const WHITESPACE_REGEX = /\s+/g;
  const DASHES_REGEX = /-+/g;
  const TRIM_DASHES_REGEX = /^-+|-+$/g;
  str = str.replace(TRIM_REGEX, "");
  str = str.toLowerCase();
  for (const [key, value] of Object.entries(charMap)) {
    str = str.replace(new RegExp(key, "g"), value);
  }
  const from = "\xE0\xE1\xE4\xE2\xE8\xE9\xEB\xEA\xEC\xED\xEF\xEE\xF2\xF3\xF6\xF4\xF9\xFA\xFC\xFB\xF1\xE7\xB7/_,:;";
  const to = "aaaaeeeeiiiioooouuuunc------";
  for (let i = 0, l = from.length; i < l; i++) {
    str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }
  str = str.replace(INVALID_CHARS_REGEX, "").replace(WHITESPACE_REGEX, "-").replace(DASHES_REGEX, "-");
  str = str.replace(TRIM_DASHES_REGEX, "");
  return str;
};
var UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
var isValidId = (id) => {
  if (typeof id !== "string") {
    return false;
  }
  const trimmedId = id.trim();
  if (trimmedId.length === 0) {
    return false;
  }
  return UUID_REGEX.test(trimmedId);
};
var isValidEmail = (email) => {
  const emailRegex = /^[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
  if (!email) return false;
  var emailParts = email.split("@");
  if (emailParts.length !== 2) return false;
  var account = emailParts[0];
  var address = emailParts[1];
  if (account.length > 64) return false;
  else if (address.length > 255) return false;
  var domainParts = address.split(".");
  if (domainParts.some((part) => part.length > 63)) return false;
  return emailRegex.test(email);
};
var WORDS_PER_MINUTE = 200;
var calculateReadTime = (text) => {
  const wordCount = text.split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.ceil(wordCount / WORDS_PER_MINUTE));
};

export { calculateReadTime, compareString, isValidEmail, isValidId, slugify };
//# sourceMappingURL=chunk-USSHZLWS.mjs.map
//# sourceMappingURL=chunk-USSHZLWS.mjs.map